import React from 'react';
import { useTranslation } from 'react-i18next';
import AutoTextfit from '../../../../../../../../shared/components/AutoTextfit';
import Image from '../../../../../../../../shared/components/Image';
import styles from './ActivePlayers.module.css';
import { useTrueMobile } from 'shared/hooks/useTrueMobile';

interface ActivePlayersProps {
  totalActivePlayers: number;
}

const DESKTOP_MAX_FONT_SIZE_PX = 21;
const MOBILE_MAX_FONT_SIZE_PX = 14;
const MIN_FONT_SIZE_PX = 9;

const ActivePlayers: React.FC<ActivePlayersProps> = ({ totalActivePlayers }) => {
  const { t } = useTranslation();
  const isMobile = useTrueMobile();

  return (
    <tr className={styles.container}>
      <td>
        <Image
          className={styles.backgroundImage}
          src="/tournaments/icons/activePlayers"
          manualAffix=".svg"
          alt="Active Players"
        />
      </td>
      <td className={styles.textWrapper}>
        <AutoTextfit
          className={styles.styledAutoTextfit}
          maxFontSize={isMobile ? MOBILE_MAX_FONT_SIZE_PX : DESKTOP_MAX_FONT_SIZE_PX}
          minFontSize={MIN_FONT_SIZE_PX}
        >
          <span className={styles.label}>{t('tournaments.active_players', 'Active Players')}</span>
          <span className={styles.playerCount}>{totalActivePlayers}</span>
        </AutoTextfit>
      </td>
    </tr>
  );
};

export default ActivePlayers;
